import { LocaleInput } from '../index.js'

export default {
  code: 'fr',
  buttonText: {
    prev: 'Précédent',
    next: 'Suivant',
    today: 'Aujourd\'hui',
    year: 'Année',
    month: 'Mois',
    week: 'Semaine',
    day: 'Jour',
    list: 'Mon planning',
  },
  weekText: 'Sem.',
  allDayText: 'Toute la journée',
  moreLinkText: 'en plus',
  noEventsText: 'Aucun événement à afficher',
} as LocaleInput
